import * as yup from "yup";
import { FormInputMeta, FormSelectInputOptionMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { SelectModuleOptions } from "@Shared/components";

export interface ISensitiveDataParametersFormMeta {
  id: FormInputMeta;
  name: FormInputMeta;
  bank: FormInputMeta;
  module: FormInputMeta;
  tableName: FormInputMeta;
  keyFieldName: FormInputMeta;
  sourceTableName: FormInputMeta;
  sourceKeyFieldName: FormInputMeta;
  srcKeyFieldNameDesc: FormInputMeta;
  sourceTableName2: FormInputMeta;
  sourceKeyFieldName2: FormInputMeta;
  srcKeyFieldNameDesc2: FormInputMeta;
  srcKeyFieldNameTitle: FormInputMeta;
  triggerCondition: FormInputMeta;
  triggerType: FormInputMeta;
  triggerEvent: FormInputMeta;

  schema: any;
}

const sensitiveDataParametersFormMeta = {} as ISensitiveDataParametersFormMeta;

sensitiveDataParametersFormMeta.id = {
  name: "id",
  type: "text",
  label: "Id",
  placeholder: "Veuillez entrer l'Id",
  validation: yup.string().required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.name = {
  name: "name",
  type: "text",
  label: "Name",
  placeholder: "Veuillez entrer le Name",
  validation: yup.string().required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.bank = {
  name: "bank",
  type: "select",
  label: "Bank",
  placeholder: "",
  options: [],
  validation: yup.string().oneOf([]).required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.module = {
  name: "module",
  type: "select",
  label: "Module",
  placeholder: "",
  options: SelectModuleOptions,
  validation: yup.string().oneOf([]).required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.tableName = {
  name: "tableName",
  type: "select",
  label: "Table Name",
  placeholder: "",
  options: [],
  validation: yup.string().oneOf([]).required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.keyFieldName = {
  name: "keyFieldName",
  type: "select",
  label: "Key Field Name",
  placeholder: "",
  options: [],
  validation: yup.string().oneOf([]).required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.sourceTableName = {
  name: "sourceTableName",
  type: "select",
  label: "Source Table Name",
  placeholder: "",
  options: [],
  validation: yup.string().oneOf([]).required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.sourceTableName2 = {
  ...sensitiveDataParametersFormMeta.sourceTableName,
  name: "sourceTableName2",
};

sensitiveDataParametersFormMeta.sourceKeyFieldName = {
  name: "sourceKeyFieldName",
  type: "select",
  label: "Source Key Field Name",
  placeholder: "",
  options: [],
  validation: yup.string().oneOf([]).required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.sourceKeyFieldName2 = {
  ...sensitiveDataParametersFormMeta.sourceKeyFieldName,
  name: "sourceKeyFieldName2",
};

sensitiveDataParametersFormMeta.srcKeyFieldNameDesc = {
  name: "srcKeyFieldNameDesc",
  type: "select",
  label: "Src. Key Field Name desc.",
  placeholder: "",
  options: [],
  validation: yup.string().oneOf([]).required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.srcKeyFieldNameDesc2 = {
  ...sensitiveDataParametersFormMeta.srcKeyFieldNameDesc,
  name: "srcKeyFieldNameDesc2",
};

sensitiveDataParametersFormMeta.srcKeyFieldNameTitle = {
  name: "srcKeyFieldNameTitle",
  type: "select",
  label: "Source Key Field Name Title",
  placeholder: "",
  options: [],
  validation: yup.string().oneOf([]).required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.triggerCondition = {
  name: "triggerCondition",
  type: "text",
  label: "Trigger Condition",
  placeholder: "",
  options: [],
  validation: yup.string().required("Champ obligatoire !"),
};

export const TriggerTypeOptions: FormSelectInputOptionMeta[] = [
  {
    label: "After",
    value: "After",
  },

  {
    label: "Before",
    value: "Before",
  },

];

sensitiveDataParametersFormMeta.triggerType = {
  name: "triggerType",
  type: "select",
  label: "Trigger Type",
  placeholder: "",
  options: TriggerTypeOptions,
  validation: yup.string().oneOf(["After", "Before"]).required("Champ obligatoire !"),
};

export const TriggerEventOptions: FormSelectInputOptionMeta[] = [
  {
    label: "Insert",
    value: "Insert",
  },

  {
    label: "Update",
    value: "Update",
  },

  {
    label: "Delete",
    value: "Delete",
  },

];

sensitiveDataParametersFormMeta.triggerEvent = {
  name: "triggerEvent",
  type: "select",
  label: "Trigger Event",
  placeholder: "",
  options: TriggerEventOptions,
  validation: yup.string().oneOf(["Insert", "Update", "Delete"]).required("Champ obligatoire !"),
};

sensitiveDataParametersFormMeta.schema = yup.object().shape(getValidationSchema(sensitiveDataParametersFormMeta));

export default sensitiveDataParametersFormMeta;